/**
 * Saisie en cours (révision du référent du 2026-10-31) : un champ que l'utilisateur a modifié
 * et qui est encore à l'écran. Sert à ne jamais recharger la page sous ses doigts (nouvelle
 * version, session expirée). Les champs de recherche et de filtre (`role="search"`,
 * `type="search"`) ne comptent pas ; un formulaire enregistré puis fermé disparaît de l'écran
 * et ne compte plus.
 */

const NON_SAISIE = new Set(['button', 'submit', 'reset', 'hidden', 'image', 'search']);

/** Le champ porte-t-il une saisie à protéger ? (exporté pour les tests) */
export function estChampDeSaisie(el: {
  tagName: string;
  type?: string;
  isContentEditable?: boolean;
  closest?: (s: string) => unknown;
}): boolean {
  const tag = el.tagName.toUpperCase();
  const champ =
    (tag === 'INPUT' && !NON_SAISIE.has((el.type ?? 'text').toLowerCase())) ||
    tag === 'TEXTAREA' ||
    tag === 'SELECT' ||
    el.isContentEditable === true;
  if (!champ) return false;
  return (el.closest?.('[role="search"], [data-sans-saisie]') ?? null) === null;
}

const modifies = new Set<Element>();
let installe = false;

/** Suit les champs modifiés (une seule fois par page). */
export function suivreSaisie(doc: Document = document): void {
  if (installe) return;
  installe = true;
  const noter = (e: Event): void => {
    const cible = e.target;
    if (cible instanceof Element && estChampDeSaisie(cible)) modifies.add(cible);
  };
  doc.addEventListener('input', noter, true);
  doc.addEventListener('change', noter, true);
  doc.addEventListener(
    'reset',
    (e) => {
      if (e.target instanceof HTMLFormElement)
        for (const el of [...modifies]) if (e.target.contains(el)) modifies.delete(el);
    },
    true,
  );
}

/** Un champ modifié est-il encore affiché ? */
export function saisieEnCours(): boolean {
  for (const el of [...modifies]) if (!el.isConnected) modifies.delete(el);
  return modifies.size > 0;
}
